import React, { useEffect, useRef } from "react";
import Form from "@rjsf/core";
import defaultValidator from "@rjsf/validator-ajv8";

interface DynamicFormProps {
    schema: any;
    uischema: any;
    children?: React.ReactNode;
    formValues?: any;
    onSubmit?: (formData: any) => void | Promise<void>;
    onChange: (formData: any) => void;
    onError?: (errors: any) => void;
    validateOnChange?: boolean;
}

const DynamicForm: React.FC<DynamicFormProps> = ({
    schema,
    uischema,
    formValues,
    onSubmit,
    onChange,
    onError,
    children,
    validateOnChange,
}) => {
    const formRef = useRef();

    const handleSubmit = (data: any) => {
        onSubmit(data);
    };

    const handleChange = (data: any) => {
        onChange(data);
        if (validateOnChange && !!formRef.current) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (formRef.current as any).validateForm();
        }
    };

    useEffect(() => {
        if (validateOnChange && !!formRef.current) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (formRef.current as any).validateForm();
        }
    }, [validateOnChange, schema]);

    const combinedUiSchema = {
        ...uischema,
        "ui:submitButtonOptions": { norender: true },
    };

    return (
        <Form
            ref={formRef}
            schema={schema}
            uiSchema={combinedUiSchema}
            formData={formValues}
            onSubmit={(e) => handleSubmit(e.schema)}
            onChange={(e) => handleChange(e.formData)}
            validator={defaultValidator}
            onError={onError}
        >
            {children}
        </Form>
    );
};

export default DynamicForm;
